import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../../helpers/toast";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigAdmin";
//var Constant = require("../../constants");
import Constant from "../../constants";
import {
  canAccessFinance,
  canManageInternalUsers,
  isOperations,
} from "../../helpers/adminRoles";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controller_count: 0,
      controller_total: 0,
      module_count: 0,
      module_total: 0,
      clinic_count: 0,
      doctor_count: 0,
      patient_count: 0,
      retailer_count: 0,
      diagnosis_count: 0,
      finance_user_count:0,
      operations_user_count: 0,
    };
  }

  // 1.To get detais after first render
  componentDidMount = () => {
    this.getControllerCount();
    this.getModuleCount();
    this.getClinicsCount();
    this.getDoctorCount();
    this.getPatientCount();
    this.getRetailerCount();
    this.getDiagnosticsCount();
    //  Roles that may not open Finance are not shown its number either, so
    //  there is nothing to fetch (and the endpoint would refuse them anyway).
    if (canAccessFinance()) {
      this.getFinanceUserCount();
    }
    //  Managing operations accounts is Super Admin only (verifyRole.ROLE_MANAGERS
    //  on the server) - same reasoning as Finance above.
    if (canManageInternalUsers()) {
      this.getOperationsUserCount();
    }
  };

  // 2.To get all Controllers Count
  getControllerCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/getControllerCount"
    )
      .then((response) => {
        var count = response.data.activeData;
        var total = response.data.totalData;
        this.setState({
          controller_count: count,
          controller_total: total,
        });
      })
      .catch((error) => { });
  }

  //3. To get all Controllers Count
  getModuleCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastermodule/getModuleCount"
    )
      .then((response) => {
        var count = response.data.activeData;
        var total = response.data.totalData;
        this.setState({
          module_count: count,
          module_total: total,
        });
      })
      .catch((error) => { });
  }

  // 4.To get all count of Clinics
  getClinicsCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/clinics"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          clinic_count: count,
        });
      })
      .catch((error) => { });
  }

  //5.To get all count of Doctors
  getDoctorCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/doctors"
    )
      .then((response) => {
        var count = response.data.data;
        this.setState({
          doctor_count: count,
        });
      })
      .catch((error) => { });
  }

  // 6. To get all count of Users
  getPatientCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/patients"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          patient_count: count,
        });
      })
      .catch((error) => { });
  }

  // 6. To get all count of Retailers
  getRetailerCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/retailer"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          retailer_count: count,
        });
      })
      .catch((error) => { });
  }

  // Get diagnostics count
  getDiagnosticsCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/diagnosis"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          diagnosis_count: count,
        });
      })
      .catch((error) => { });
  }

  // Get finance user count
  getFinanceUserCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/finance"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          finance_user_count: count,
        });
      })
      .catch((error) => { });
  }

  //  Get operations user count. There is no dedicated count endpoint (unlike
  //  Finance) - ViewOperationsUsers.js already fetches the same full list, so
  //  this just reuses it and takes the length rather than adding a new route.
  getOperationsUserCount() {
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/Operations/getAllOperationsList",
      {}
    )
      .then((response) => {
        var users = response.data.data || [];

        this.setState({
          operations_user_count: users.length,
        });
      })
      .catch((error) => { });
  }

  render() {
    const {
      controller_count,
      controller_total,
      module_count,
      module_total,
      pages,
    } = this.state;
    //  Finance is closed to operations: the card stays on the dashboard so the
    //  layout reads the same as an admin's, but greyed out and going nowhere.
    const financeOpen = canAccessFinance();
    //  Operations user management is Super Admin only - operations cannot see
    //  this card unlocked either, same treatment as Finance.
    const opsManageable = canManageInternalUsers();
    //  Operations only owns Pharmacies - the rest of the dashboard cards are
    //  someone else's numbers, so they are hidden rather than shown/greyed.
    const opsOnly = isOperations();

    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <h3>Dashboard</h3>
                </div>
              </div>

              <div className="dash_content">
                <div className="row">
                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="doc_info_box admin_blue">
                      <div className="info-box-icon bg-red">
                        <i className="fa fa-hospital-o"></i>
                      </div>
                      <div className="info_box_content ">
                        <Link
                          to="/admin/Viewclinics"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            No Of Clinics {" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.clinic_count}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  )}

                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="doc_info_box admin_violet">
                      <span className="info-box-icon bg-aqua">
                        <i className="fa fa-user-md"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/admin/Viewdoctors"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            No Of Doctors {" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.doctor_count}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  )}

                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="doc_info_box admin_purple">
                      <span className="info-box-icon bg-blue">
                        <i className="fa fa-user"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/admin/Viewpatients"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            No Of Patients {" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.patient_count}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  )}
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="doc_info_box admin_lightblue">
                      <span className="info-box-icon bg-green">
                      <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/admin/ViewRetailers"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            Pharmacies {" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.retailer_count}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                      <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/admin/ViewDiagnostics"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            Diagnostics {" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.diagnosis_count}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                  )}

                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div
                      className={
                        "doc_info_box admin_orange" +
                        (financeOpen ? "" : " ops-locked-card")
                      }
                      title={
                        financeOpen
                          ? ""
                          : "Finance is not available for your role"
                      }
                    >
                      <span className="info-box-icon bg-orange">
                      <i className={financeOpen ? "fa fa-hospital-o" : "fa fa-lock"}></i>
                      </span>
                      <div className="info_box_content">
                        {financeOpen ? (
                          <Link
                            to="/admin/ViewFinanceUsers"
                            className="dash_content_item"
                          >
                            <h3 className="info-box-text">
                              Finance {" "}
                            </h3>
                            <p className="info-box-number">
                              {this.state.finance_user_count}
                            </p>
                          </Link>
                        ) : (
                          <div className="dash_content_item">
                            <h3 className="info-box-text">
                              Finance {" "}
                            </h3>
                            <p className="info-box-number">&mdash;</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  )}

                  {!opsOnly && (
                  <div className="col-6 col-sm-4 col-md-2">
                    <div
                      className={
                        "doc_info_box admin_blue" +
                        (opsManageable ? "" : " ops-locked-card")
                      }
                      title={
                        opsManageable
                          ? ""
                          : "Operations user management is not available for your role"
                      }
                    >
                      <span className="info-box-icon bg-blue">
                      <i className={opsManageable ? "fa fa-users" : "fa fa-lock"}></i>
                      </span>
                      <div className="info_box_content">
                        {opsManageable ? (
                          <Link
                            to="/admin/ViewOperationsUsers"
                            className="dash_content_item"
                          >
                            <h3 className="info-box-text">
                              Operations {" "}
                            </h3>
                            <p className="info-box-number">
                              {this.state.operations_user_count}
                            </p>
                          </Link>
                        ) : (
                          <div className="dash_content_item">
                            <h3 className="info-box-text">
                              Operations {" "}
                            </h3>
                            <p className="info-box-number">&mdash;</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  )}

                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
